import { Tag, TagLabel } from '@chakra-ui/react';

import { formatDate, parseDate } from '../../utils/dateUtils';

export const AsOfDateTag = ({ dateString, isOutOfDate }: { dateString?: string; isOutOfDate?: boolean }) => {
    if (!dateString) {
        return null;
    }
    return (
        <Tag colorScheme={isOutOfDate ? 'red' : 'gray'}>
            <TagLabel>Data as of {formatDate(parseDate(dateString))}</TagLabel>
        </Tag>
    );
};
